import { render, staticRenderFns } from "./SidebarHelp.vue?vue&type=template&id=6ebcf2c9&scoped=true"
import script from "./SidebarHelp.vue?vue&type=script&lang=js"
export * from "./SidebarHelp.vue?vue&type=script&lang=js"
import style0 from "./SidebarHelp.vue?vue&type=style&index=0&id=6ebcf2c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebcf2c9",
  null
  
)

export default component.exports